import { DeliveryDetailsRow, GetDeliveryDetailsResponse } from '@/api/receive';
import { UIList, UIListSubHeader } from '@/components/ui/List';
import DeliveryListItem from '@/pages/ManageDelivery/PageManageDeliveryDetails_Partial/DeliveryList/DeliveryListItem';
import React from 'react';

type ManageDeliveryFlowType = /*'MNDL' |*/ 'PDM';

interface DeliveryListItemProps {
  deliveryNumber: string;
  delivery: GetDeliveryDetailsResponse;
  visibleEpcs: DeliveryDetailsRow[];
  flowType: ManageDeliveryFlowType;
}

const DeliveryList: React.FC<DeliveryListItemProps> = ({
  deliveryNumber,
  delivery,
  visibleEpcs,
  flowType,
}: DeliveryListItemProps) => {
  const [expanded, setExpanded] = React.useState<boolean>(true);

  return (
    <UIList
      subheader={
        <UIListSubHeader
          title={deliveryNumber || ''}
          accordion={
            visibleEpcs.length === 0
              ? undefined
              : {
                  expanded,
                  toggleAccordionState: setExpanded,
                }
          }
          showOnlyZeroCount={visibleEpcs.length === 0}
          style={{height: '32px'}}
        />
      }
      padding={[0, 0]}
      margin={[0, 0, 24]}
      bordered
      backgrounded
    >
      {expanded && (
        <>
          {visibleEpcs.map((epc, index) => (
            <DeliveryListItem
              {...epc}
              key={`${deliveryNumber}-${index}`}
              flowType={flowType}
              deliveryNumber={deliveryNumber}
              epcsInTransit={delivery.epcsInTransit ?? []}
            />
          ))}
        </>
      )}
    </UIList>
  );
};

export default DeliveryList;
